export const formatDate = (date) => {
  let fecha = null;
  if (typeof date === "string") {
    fecha = new Date(parseInt(date));
  } else {
    fecha = date;
  }

  const dd = fecha.getDate();
  const mm = fecha.getMonth() + 1;
  const yy = fecha.getFullYear();

  let day = dd;
  let month = mm;

  if (dd.toString().length === 1) {
    day = `0${dd}`;
  }

  if (mm.toString().length === 1) {
    month = `0${mm}`;
  }

  return `${day}/${month}/${yy}`;
};
